var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'tw-border-b dark:tw-border-gray-700 tw-py-4': _vm.border,
  }},[_c('div',{staticClass:"tw-text-gray-500 dark:tw-text-gray-400"},[_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"tw-mt-1 tw-font-medium"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }